import { Pipe, PipeTransform } from '@angular/core';
import { SettingService } from '../services/setting/setting.service';

@Pipe({
  name: 'param'
})
export class ParamPipe implements PipeTransform {

  constructor(
    private _setting: SettingService,
  ) {
  }

  transform(value: string, args: string): string {
    return this._setting.getParamValueName(args, value);
  }

}
